<template>
  <div class="wrapper">


    <CModal
      :show.sync="gallery_dialog"
      :close-on-backdrop="false"
      :centered="true"
      size="lg"
      class="no-border"
      title="گالری"
      color="white"
    >


      <div>
        <ImageGalleryCapture :id="'capture_image'+this.id"/>
        <CRow >

          <CCol col="3" v-for="(image,img_index) in gallery_images" :key="'img'+img_index">

            <div
              style="position: relative;
    text-align: center;margin: 5px;border: 0"
            >
              <div>
                <div @click="delete_image_from_server(img_index)">
                  <img
                    style="position: absolute;top: -3px;left: 25px;width: 25px;cursor: pointer;"

                    v-if="image.has_file"
                    size="sm"
                    src="/images/delete.svg"

                  />
                </div>

                <div
                  @click="open_file_selector(img_index)"
                >
                  <img style="border-radius: 5px;cursor: pointer;height: 100px;"
                       width="100px"
                       :src="image.preview"
                  />
                </div>

              </div>


            </div>
          </CCol>
        </CRow>
        <div>
          <div class="form-group">

            <input
              type="file"
              label="تصویر"

              :id="id"
              v-show="false"
              @change="handleFileUpload"
            />

          </div>

<!--          <hr style="margin: 3px;">-->
        </div>

      </div>
      <template #footer>

        <button
          class="blue-button-modal"
          @click="gallery_dialog = false"
        >بستن
        </button>
      </template>
    </CModal>


  </div>

</template>

<script>
import Vue from 'vue';
import axios from "axios";
import {bus} from "../../main";

import ImageGalleryCapture from "./ImageGalleryCapture.vue";
export default {
  name: 'GalleryModals',
  components:{
    ImageGalleryCapture
  },
  data() {
    return {
      id: "image_id" + new Date().getTime() + "_" + this.$vnode.tag,

      gallery_images: [{preview: '/images/upload_placeholder.svg', file: null, id: 0, has_file: false}],
      gallery_dialog: false,
      gallery_record_id: 0,
      selected_file_index: 0,
    }
  },
  mounted() {

    bus.$on('capture_image'+this.id, (data) => {
      // alert(data);

      this.add_gallery(data)
      // console.log(this.translate_values)
    });
    bus.$on('open_gallery_dialog', (data) => {
      // alert(data);
      var self = this;

      this.gallery_record_id = data

      self.gallery_dialog = true

      self.get_gallery()

    });
  }, methods: {
    get_gallery() {

      let self = this;
      let url = '/api/admin/get_product_gallery'



      var formData = new FormData();
      formData.append("product_id",this.gallery_record_id)
      axios.post(url,formData, {}).then((res) => {
          self.gallery_images = []
          let items = res.data
          items.forEach(function (val) {
            self.gallery_images.push({
              preview: val.product_image,
              file: null,
              id: val.id,
              file_name: val.image,
              has_file: true
            })

          })
          self.gallery_images.push({preview: '/images/upload_placeholder.svg', file: null, id: 0, has_file: false})
          if (self.gallery_images.length == 0) {
            self.gallery_images = [{preview: '/images/upload_placeholder.svg', file: null, id: 0, has_file: false}]
          }
          // console.log(self.translate_values)

          self.gallery_dialog = true


      }).catch(function (error) {
        console.log(error);
      });

    },

    add_gallery(base64) {

      let self = this;
      let url = '/api/admin/add_product_gallery'


      var formData = new FormData();
      formData.append("product_id",this.gallery_record_id)
      if(base64==null){
        formData.append("file", self.gallery_images[self.selected_file_index].file)
      }else{
        formData.append("file_base64", base64)
      }


      axios.post(url, formData, {headers: {
          'content-type': 'multipart/form-data'
        }}).then((res) => {

        self.get_gallery()

      }).catch(function (error) {
        console.log(error);
      });

    },

    handleFileUpload(e) {
      console.log("handle upload")
      var self = this;
      var myfile = e.target.files[0];
      if (myfile == null) {
        return
      }
      Vue.set(self.gallery_images, self.selected_file_index, {
        preview: URL.createObjectURL(myfile),
        file: myfile,
        id: 0,
        has_file: true
      });
      // Vue.set(self.files,self.selected_file_index, myfile);
      // self.files[self.selected_file_index] = myfile;

      e.target.value = null;
      e.target.files = null;
      this.$emit('update:gallery_files', self.files)

      this.gallery_images.push({preview: '/images/upload_placeholder.svg', file: null, id: 0, has_file: false})
      this.add_gallery()
    },
    open_file_selector(index) {
      console.log("clicked on image")
      var self = this;
      if (!self.gallery_images[index].has_file) {
        this.selected_file_index = index
        document.getElementById(this.id).click()
      }

    },

    delete_image_from_server(index) {
      let self = this;
      let url = '/api/admin/delete_product_gallery'

      var formData = new FormData();
      formData.append("product_id",this.gallery_record_id)
      formData.append("image_id",this.gallery_images[index].id)


      axios.post(url, formData, {}).then((res) => {
        self.get_gallery()


      }).catch(function (error) {
        console.log(error);
      });
    }

  },


}
</script>
<style>
.no-border .modal-header {

  border: 0px;
}
</style>
